/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CheckEligibilityDetails
 */
export interface CheckEligibilityDetails {
    /**
     * ID of the current admission-status history row that was evaluated. Send it as expected_admission_status_info_id when reverting.
     */
    admission_status_info_id?: string;
    /**
     * Name of the bed involved in the conflict or action
     */
    bed_name?: string;
    /**
     * 
     */
    previous_bed_name?: string;
    /**
     * 
     */
    previous_bed_id?: string;
    /**
     * 
     */
    current_bed_name?: string;
    /**
     * 
     */
    bed_change_date?: string;
    /**
     * 
     */
    swap_date?: string;
    /**
     * 
     */
    swapped_with_lead_id?: string;
    /**
     * 
     */
    swapped_with_lead_name?: string;
    /**
     * 
     */
    other_resident_current_bed_name?: string;
    /**
     * 
     */
    other_resident_original_bed_name?: string;
}

/**
 * Check if a given object implements the CheckEligibilityDetails interface.
 */
export function instanceOfCheckEligibilityDetails(value: object): value is CheckEligibilityDetails {
    return true;
}

export function CheckEligibilityDetailsFromJSON(json: any): CheckEligibilityDetails {
    return CheckEligibilityDetailsFromJSONTyped(json, false);
}

export function CheckEligibilityDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): CheckEligibilityDetails {
    if (json == null) {
        return json;
    }
    return {
        
        'admission_status_info_id': json['admission_status_info_id'] == null ? undefined : json['admission_status_info_id'],
        'bed_name': json['bed_name'] == null ? undefined : json['bed_name'],
        'previous_bed_name': json['previous_bed_name'] == null ? undefined : json['previous_bed_name'],
        'previous_bed_id': json['previous_bed_id'] == null ? undefined : json['previous_bed_id'],
        'current_bed_name': json['current_bed_name'] == null ? undefined : json['current_bed_name'],
        'bed_change_date': json['bed_change_date'] == null ? undefined : json['bed_change_date'],
        'swap_date': json['swap_date'] == null ? undefined : json['swap_date'],
        'swapped_with_lead_id': json['swapped_with_lead_id'] == null ? undefined : json['swapped_with_lead_id'],
        'swapped_with_lead_name': json['swapped_with_lead_name'] == null ? undefined : json['swapped_with_lead_name'],
        'other_resident_current_bed_name': json['other_resident_current_bed_name'] == null ? undefined : json['other_resident_current_bed_name'],
        'other_resident_original_bed_name': json['other_resident_original_bed_name'] == null ? undefined : json['other_resident_original_bed_name'],
    };
}

export function CheckEligibilityDetailsToJSON(json: any): CheckEligibilityDetails {
    return CheckEligibilityDetailsToJSONTyped(json, false);
}

export function CheckEligibilityDetailsToJSONTyped(value?: CheckEligibilityDetails | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'admission_status_info_id': value['admission_status_info_id'],
        'bed_name': value['bed_name'],
        'previous_bed_name': value['previous_bed_name'],
        'previous_bed_id': value['previous_bed_id'],
        'current_bed_name': value['current_bed_name'],
        'bed_change_date': value['bed_change_date'],
        'swap_date': value['swap_date'],
        'swapped_with_lead_id': value['swapped_with_lead_id'],
        'swapped_with_lead_name': value['swapped_with_lead_name'],
        'other_resident_current_bed_name': value['other_resident_current_bed_name'],
        'other_resident_original_bed_name': value['other_resident_original_bed_name'],
    };
}

